// @flow
import React from 'react';
import LoadingIndicator from 'box-ui-elements/es/components/loading-indicator/LoadingIndicator';
import css from './loading-form-page.module.scss';

const LoadingForm = () => {
  return (
    <div className={css.container}>
      <LoadingIndicator />
    </div>
  );
};

export { LoadingForm };
export default LoadingForm;
